import { objectsEqual } from "./object";

export const arraysEqual = (a1: any, a2: any): boolean =>  a1.length === a2.length && a1.every((o, idx) => objectsEqual(o, a2[idx]));